import { linkedPatientWithCookieApi } from "@mgdx/api/lib/linkedPatientWithCookieApi";
import { getApiError } from "@mgdx-libs/error-handler";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import { logger } from "@mgdx-libs/logger";
import { Dispatch } from "redux";

import { setCurrentUserWithDispatch } from "../../ducks/currentUser";
import { createCustomTokenUser } from "../../hooks/useInitializeLiff";

export const createNewPatientWithMccmOidcFirebaseUser = async (dispatch: Dispatch) => {
  // NOTE:
  // STG環境にて新規アカウントで/linked-patientが403や429エラーになる場合、user-matsukiyococokaraのBasic認証が設定されている可能性あり
  // Basic認証はないのが正常な状態
  // 過去の対応スレ https://caadtech.slack.com/archives/C013MQ4CAQL/p1749113891548279
  const response = await linkedPatientWithCookieApi
    .postLinkedPatients({
      postLinkedPatientRequestBody: {},
    })
    .catch(async (errorOrResponse) => {
      throw await getApiError(errorOrResponse);
    });

  const { patient } = response;
  logger.debug("patient: %o", patient);

  if (!patient) {
    const error = new Error("patient is undefined");
    logger.error(error.message);
    throw error;
  }

  await forceRefreshAccessToken();
  setCurrentUserWithDispatch(dispatch, patient);

  return patient;
};

export const linkExistingPatientWithMccmOidcFirebaseUser = async (
  dispatch: Dispatch,
  { code, state }: { code?: string; state?: string }
) => {
  const response = await linkedPatientWithCookieApi
    .postLinkedPatients({
      postLinkedPatientRequestBody: { linkUserToken: code },
      state,
    })
    .catch(async (errorOrResponse) => {
      throw await getApiError(errorOrResponse);
    });

  const { patient, customToken } = response;
  logger.debug("patient: %o", patient);

  if (!patient || !customToken) {
    const error = new Error(`patient or customToken is undefined: patient=${patient}, customToken=${customToken}`);
    logger.error(error.message);
    throw error;
  }

  await createCustomTokenUser(customToken);
  setCurrentUserWithDispatch(dispatch, patient);

  return patient;
};
